import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import AccountService from "../services/AccountService";
import { useDispatch } from "react-redux";
import { inUser } from "../redux/slices/auth.slice";

//const loginUsuario: string = process.env.REACT_APP_USER_SESSION || '';

export const useLogin = () => {
    const { instance } = useMsal(); // Hook debe estar dentro de un hook personalizado
    const dispatch = useDispatch();
   
    

    const setLogin = async () => {
        try {
            const response = await instance.loginPopup({ ...loginRequest });
            const username = response.account.username.split('@')[0];

            let usuario = "mrealpe";
            let delegado = "cabadr";

            let delegado2 = "gsorian";
            let decano = "aramire";
            let vicerrectorado = "mbuestan";
            let administrador = "akvargas";

            const userData = await AccountService.LoginAyudantias(username);

            dispatch(inUser({
                userData: {
                    idpersona: userData.user.idpersona,
                    netId: userData.user.netId,
                    nombres: userData.user.nombres,
                    apellidos: userData.user.apellidos,
                    iddevinvuser: userData.user.iddevinvuser,
                    email : userData.user.email,
                    //tipoPersona: userData.user.tipoPersona,
                    username: userData.user.username,
                    //idunidad: userData.user.idunidad,
                    esinvestigacion : userData.user.esinvestigacion,
                    codEstudiante: userData.user.codEstudiante,
                    rolesInvestigacion: userData.user.rolesInvestigacion,
                    unidadesDirectivo : userData.user.unidadesDirectivo,
                    unidadesVicerrector : userData.user.unidadesVicerrector,
                    unidadesDelegado : userData.user.unidadesDelegado
                },
                token: userData.token,
                isAuth: true,
                isLoading: false,
                expiration: false,
                expirationTime: Date.now() + 2 * 60 * 60 * 1000
            }));
        } catch (error) {
            console.error("Error de autenticación:", error);
        }
    };

    return { setLogin };
};